import {ApolloProvider} from "@apollo/client";
import {CookiesProvider} from "react-cookie";
import {IconContext} from "react-icons";
import {Outlet, ScrollRestoration} from "react-router";

import {PublicUserContextProvider} from "@/components/context/PublicUserContextProvider.tsx";
import client from "@/lib/api/apolloClient.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";

import MarketingFooter from "./components/marketingfooter/MarketingFooter";
import MarketingHeader from "./components/marketingheader/MarketingHeader";

import "./PublicLayout.scss";

export const PublicLayout = () => (
  <UpErrorBoundary>
    <ApolloProvider client={client}>
      <CookiesProvider>
        <PublicUserContextProvider>
          <IconContext.Provider value={{size: "1.25em", style: {verticalAlign: "text-top"}}}>
            <UpErrorBoundary>
              <MarketingHeader />
              <ScrollRestoration />
              <Outlet />
              <MarketingFooter />
            </UpErrorBoundary>
          </IconContext.Provider>
        </PublicUserContextProvider>
      </CookiesProvider>
    </ApolloProvider>
  </UpErrorBoundary>
);
